import React from "react";
import IMG from "../../../constants/image";
import ImageBasic from "../../Common/Image/ImageBasic";
import {text} from "../../../constants/text";

const NotificationMessage = () => (
    <div className="flex items-center justify-center text-gray-500 text-xs bg-[#FFFCF3] p-4 rounded-[10px] space-x-2">
        <ImageBasic className='w-6' src={IMG.icon.errorOutlineGray} alt='icon error'/>
        <div>{text.packageBeforeCarrierPickup}</div>
    </div>
);
export default NotificationMessage;